import axios from "axios";
import apiUrl from "../../Apiurl";
import apriUrl from "../../interfaccia/funzioniComuni/apriUrl";

const stampaReportSplit = async function (token, ordiniSelezionati, magazzino) {
  if (!token) {
    console.warn("sto aspettando un token");
    return;
  }
  let idSpedizioni;
  let idOrdini;
  try {
    const selezione = ordiniSelezionati || [];
    idSpedizioni = selezione
      .filter((ord) => ord && typeof ord === "object")
      .map((ord) => Number(ord.idSped))
      .filter((id) => Number.isInteger(id) && id > 0);
    idOrdini = selezione
      .map((ord) => (ord && typeof ord === "object" ? ord.idPS : ord))
      .map((id) => String(id || ""))
      .filter((id) => id);
  } catch (err) {
    console.log("Errore nella creazione array ID ordini: " + err);
    throw err;
  }

  try {
    const data = {
      idSpedizioni: idSpedizioni,
      idOrdini: idOrdini,
      magazzino: magazzino,
    };
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    const url = "/logistica/pdf/reportSplit";

    axios
      .post(apiUrl + url, data, config)
      .then((data) => apriUrl(data.data));
  } catch (err) {
    console.log("Errore nell'invio degli ordini alle API': " + err);
    throw err;
  }
};

export default stampaReportSplit;
